<template lang="pug">
.FReinsuranceCard(:style="style")
  FIcon(
    size="64"
    :name="icon"
  )
  h4 {{ text }}
</template>

<style lang="stylus">
.FReinsuranceCard
  display flex
  flex-direction column
  align-items flex-start
  justify-content space-between
  min-height rem(304)
  max-width rem(344)
  padding rem(40)
  border-radius rem(16)
  color var(--FReinsuranceCard--color)
  background var(--FReinsuranceCard--backgroundColor)

  h4
    margin-top rem(32)
</style>

<script setup lang="ts">
export interface FReinsuranceCardProps {
  /**
   * Text of the card
   */
  text: string;
  /**
   * Icon of the card
   */
  icon: Icon;
  /**
   * Text color of the card
   */
  color?: string;
  /**
   * Background color of the card
   */
  backgroundColor?: string;
}

const props = withDefaults(defineProps<FReinsuranceCardProps>(), {
  color: 'neutral--light-5',
  backgroundColor: 'primary',
});

const style = computed(
  (): Style => ({
    '--FReinsuranceCard--color': getCssColor(props.color),
    '--FReinsuranceCard--backgroundColor': getCssColor(props.backgroundColor),
  })
);
</script>
